import { z } from 'zod';

export const workspaceNameSchema = z.object({
  name: z
    .string()
    .trim()
    .min(2, 'Use at least 2 characters.')
    .max(60, 'Keep it under 60 characters.'),
});

export type WorkspaceNameValues = z.infer<typeof workspaceNameSchema>;

export const WORKSPACE_NAME_DEFAULTS: WorkspaceNameValues = { name: '' };
